import { IPrice, Languages, SetStateType } from 'commonTypes';
import { ChangeEvent, FormEvent } from 'react';
import { RGBColor } from 'react-color';

export const phoneMask = (
  e: InputEvent | FormEvent<HTMLInputElement>,
  setPhone: SetStateType<string>,
) => {
  const target = e.target as HTMLInputElement;
  const x = target.value.replace(/\D/g, '');
  // .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  // const phone = !x[2]
  //   ? x[1]
  //   : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  const phone = x;
  target.value = phone;
  setPhone(phone);
};

export function classNames(...classes: (string | undefined | false | null)[]) {
  return classes.filter(Boolean).join(' ');
}

export const checkFieldNotEmpty = (obj: object) => {
  const filterArr = Object.values(obj).filter((val) => !val.trim());
  return filterArr.length === 0;
};

export const validatePrice = (priceField: IPrice) => {
  let valid = true;
  priceField?.prices?.forEach((price) => {
    if (priceField.type === 'single') {
      if (!+price.value) {
        valid = false;
      }
    } else {
      if (!(price.name?.trim() && +price.value)) {
        valid = false;
      }
    }
  });
  return valid;
};

export const returnNumberPrice = (price: IPrice) => {
  if (price.type === 'multiple') {
    return +(price?.prices.find((price) => price.is_default)?.value || 0);
  } else if (price.type === 'single') {
    return +(price?.prices[0].value || 0);
  } else {
    return 0;
  }
};

export const sortedTranslateObj = ({
  translate,
  langs,
}: {
  translate: Record<Languages, string>;
  langs: Languages[];
}) => {
  // @ts-ignore
  let sortedObj: Record<Languages, string> = {};
  const bufTranslate = { ...translate };
  if (langs?.length > 0) {
    langs.forEach((lang) => {
      sortedObj[lang] = translate[lang];
      delete bufTranslate[lang];
    });
    sortedObj = {
      ...sortedObj,
      ...bufTranslate,
    };
    return sortedObj;
  } else {
    return bufTranslate;
  }
};

export function isEqual<T>(object1: T, object2: T) {
  const props1 = Object.getOwnPropertyNames(object1) as Array<keyof T>;
  const props2 = Object.getOwnPropertyNames(object2) as Array<keyof T>;

  if (props1.length !== props2.length) {
    return false;
  }

  for (let i = 0; i < props1.length; i += 1) {
    const prop = props1[i];
    const bothAreObjects =
      typeof object1[prop] === 'object' &&
      object1[prop] !== null &&
      typeof object2[prop] === 'object' &&
      object2[prop] !== null;

    if (
      (!bothAreObjects && object1[prop] !== object2[prop]) ||
      (bothAreObjects && !isEqual(object1[prop], object2[prop]))
    ) {
      return false;
    }
  }

  return true;
}

export const positiveNumberInput = (e: InputEvent | ChangeEvent, easy = false) => {
  const target = e.target as HTMLInputElement;
  const value = target.value;
  if (easy) {
    return value.replace(/[^0-9]/g, '');
  } else {
    return value.replace(/^\.|[^\d.]|\.(?=.*\.)|^0+(?=\d)/g, '');
  }
};

export const positiveNumberValue = (value: string, easy = false) => {
  if (easy) {
    // @ts-ignore
    return Math.trunc(value);
  } else {
    return value.replace(/^\.|[^\d.]|\.(?=.*\.)|^0+(?=\d)/g, '');
  }
};
export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 B';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const rgbaNormalize = (color: RGBColor) => {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color?.a || 1})`;
};

export function parsePhoneNumber(phoneNumber: string): { code: string; number: string } {
  // Regular expression to match the country code (up to 3 digits after the '+') and the rest of the number
  const regex = /^\+(\d{1,3})(\d+)$/;
  const match = phoneNumber.match(regex);

  if (!match) {
    throw new Error('Invalid phone number format');
  }

  // Extract the country code and the rest of the phone number from the match
  const [, code, number] = match;
  return {
    code: '+' + code,
    number: number,
  };
}

export function getPaymentSystem(cardNumber: string) {
  const normalizedCardNumber = cardNumber.replace(/\D/g, ''); // Remove non-digit characters

  if (/^4\d{12}(\d{3})?$/.test(normalizedCardNumber)) {
    return 'Visa'; // Visa: 13 or 16 digits, starts with 4
  } else if (/^5[1-5]\d{14}$/.test(normalizedCardNumber)) {
    return 'Mastercard'; // MasterCard: 16 digits, starts with 51-55
  } else {
    return null; // Unknown or not supported
  }
}
export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const validateEmail = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
};

export const returnSubscriptionPeriod = (period: string) => {
  if (period === '3 months') {
    return 'Quarterly';
  } else if (period === '1 month') {
    return 'Monthly';
  } else if (period === '12 months') {
    return 'Annual';
  } else return '';
};
